<ng-template #content let-modal>
  <div class="tw-relative tw-w-full tw-rounded-lg tw-shadow">
    <!-- begin::Modal Header -->
    <div class="tw-rounded-t tw-border-b tw-px-4 tw-py-2.5">
      <div class="tw-mb-1.5 tw-flex tw-items-center tw-justify-between">
        <span class="tw-text-[1.0625rem] tw-uppercase tw-text-primary-600">
          {{ headerTitle() }}
        </span>
        <button
          type="button"
          class="tw-ms-auto tw-inline-flex tw-h-8 tw-w-8 tw-items-center tw-justify-center tw-rounded-lg tw-bg-transparent tw-text-sm tw-text-gray-400 hover:tw-bg-gray-200 hover:tw-text-gray-900 dark:hover:tw-bg-gray-600 dark:hover:tw-text-white"
          appClickStopPropagation
          (click)="modal.dismiss('Cross click')"
        >
          <svg
            class="tw-h-3 tw-w-3"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 14 14"
          >
            <path
              stroke="currentColor"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
            ></path>
          </svg>
        </button>
      </div>

      <form [formGroup]="dataForm">
        <input
          type="text"
          class="tw-block tw-w-full tw-rounded-sm tw-border tw-border-base-400 tw-px-3 tw-py-1.5 tw-text-sm tw-text-base-content tw-outline-none tw-transition-shadow focus:tw-ring focus:tw-ring-primary-100"
          placeholder="Tìm kiếm"
          required=""
          formControlName="search"
          ngbAutoFocus
          #searchControl
        />
      </form>
    </div>

    <!-- begin::Modal Body -->
    <div
      #body
      class="tw-h-screen tw-max-h-[calc(100vh_-_7rem)] tw-min-h-20 tw-overflow-auto tw-rounded-b-md sm:tw-h-[calc(100vh_-_9.375rem)] sm:tw-max-h-[40rem]"
    >
      <cdk-virtual-scroll-viewport
        #scrollViewport
        itemSize="60"
        class="tw-flex tw-h-full tw-flex-col"
      >
        <div
          *cdkVirtualFor="let item of airports"
          class="tw-min-h-16 tw-cursor-pointer tw-border-b tw-p-2.5 tw-transition-colors hover:tw-bg-base-200"
          (click)="onSelect(item)"
        >
          <div class="tw-flex tw-items-center tw-gap-4">
            <img
              class="tw-size-[2.8125rem] tw-rounded-full"
              [src]="cdnUrl + '/airports/cities/' + item.img"
              (error)="item.img = 'icon-default.png'"
            />
            <div class="tw-flex tw-flex-col">
              <span
                class="tw-text-lg tw-font-medium tw-capitalize tw-text-accent"
              >
                {{ item.city }}
              </span>
              <span>{{ item.code }}</span>
            </div>
          </div>
        </div>
      </cdk-virtual-scroll-viewport>
    </div>
    <!-- begin::Modal Body -->
  </div>
</ng-template>
